<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">General/Non-Inventory Receipt #{{data.code}}</h4>
                    <p class="text-subtitle-1">Non Inventory Receipt Information</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3" v-if="hasPermission(perm.general_receipt.post) && (data && data.state_code == stateDraft)">
                    <v-btn block color="primary" @click="handlePost">
                        <v-icon left>mdi-post</v-icon>
                        post
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn block :depressed="data && data.state_code == stateDraft" :color="data && data.state_code == statePosted ? 'primary': ''" @click="handlePrint">
                        <v-icon left>mdi-printer</v-icon>
                        print
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3" v-if="hasPermission(perm.general_receipt.update) && (data && data.state_code == stateDraft)">
                    <v-btn block depressed @click="handleEdit">
                        <v-icon left>mdi-pencil</v-icon>
                        edit
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3" v-if="hasPermission(perm.general_receipt.delete) && (data && data.state_code == stateDraft)">
                    <v-btn block depressed color="error--text" :loading="deleteLoading" @click="handleDelete">
                        <v-icon left>mdi-delete</v-icon>
                        delete
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <GeneralReceipt :value="data"/>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import PAlert from './../../components/common/PAlert';
import GeneralReceipt from "./../../components/purchase/GeneralReceipt.vue";
import generalReceiptAPI from './../../services/purchase/generalReceipt';
import { mapActions } from 'vuex';
import authorize from '../../utils/authorize';

export default {
    name: "GeneralReceiptDisplayView",
    components: {
        PAlert,
        GeneralReceipt,
    },
    data(){
        return {
            id: null,
            loading: false,
            deleteLoading: false,
            data: {},
            alert: {
                value: false,
                content: 'Are you sure',
                callback: null
            },
            perm: permissions,
            stateDraft: 1,
            statePending: 2,
            statePosted: 3
        }
    },
    methods: {
        hasPermission(code) {
            return authorize(code)
        },
        ...mapActions({
            findByID: "purchase/generalReceipt/findByID",
            post: "purchase/generalReceipt/post",
            delete: "purchase/generalReceipt/delete",
            snackbar: "ui/snackbar/show"
        }),
        getAsync(){
            this.loading = true;
            this.findByID(this.id).then(response => {
                this.data = response.data;
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({color: "error", text: message});
                }).finally(() => {
                    this.loading = false;
                })
        },
        handleList() {
            this.$router.push({name: "GeneralReceiptList"})
        },
        handleEdit() {
            this.$router.push({ name: "GeneralReceiptEdit", params: { id : this.id } })
        },
        handlePost() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to post this goods receipt?", callback: this.postAsnyc}
        },
        postAsnyc() {
            this.loading = true;
            this.post(this.data).then(response => {
                this.data = response.data;
                this.snackbar({color: "success", text: "Goods Receipt Posted Successfully"});
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({color: "error", text: message});
            }).finally(() => {
                this.loading = false;
            })
        },
        handleDelete() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to delete?", callback: this.deleteGeneralReceipt}
        },
        deleteGeneralReceipt() {
            this.deleteLoading = true
            this.delete(this.data).then(() => {
                this.snackbar({text: "Good Receipt Deleted", color: "success"})
                this.$router.replace({ name: "GeneralReceiptList"})
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({text: message, color: "error"})
            }).finally(() => this.deleteLoading = false)
        },
        handlePrint() {
            generalReceiptAPI.print(this.data)
                .then(response => {
                    var printWindow = window.open('','','width=800,height=600');
                    printWindow.document.write(response.data);
                    printWindow.document.close();
                    printWindow.focus();
                    printWindow.print();
                    printWindow.close();
                })
        },
    },
    created() {
        this.id = this.$route.params.id;
        this.getAsync()
    },
    beforeRouteUpdate(to, from, next) {
        this.id = to.params.id;
        this.getAsync()
        next();
    }
}
</script>

<style>

</style>